import InsightsCard from '../insights-card/InsightsCard';
import InsightVI, { InsightVIProps } from '../insight-vi/InsightVI';
import { useAppSelector } from '@customer/store/hooks';
import { VICategory, VILevel, VISummaryModel, VIType } from '@customer/store/apis/interactionsApi';
import { useMemo } from 'react';

const getPlaceholder = (vit: VICategory): InsightVIProps => ({
  vit: vit,
  alarm: undefined,
  alert: undefined,
  aware: undefined,
});

const getFilteredSummary = (summary: VISummaryModel, viFilter: VIType[]): InsightVIProps => {
  // If filters are in use, replace any vits that have not been selected with 'null'
  if (viFilter.length) {
    return {
      vit: summary.vit,
      alarm: viFilter.includes(VIType[`${summary.vit}${VILevel.Alarm}`]) ? summary.alarm : null,
      alert: viFilter.includes(VIType[`${summary.vit}${VILevel.Alert}`]) ? summary.alert : null,
      aware: viFilter.includes(VIType[`${summary.vit}${VILevel.Aware}`]) ? summary.aware : null,
    };
  }

  return summary;
};

const getDisplaySummary = (
  summaries: VISummaryModel[] | undefined,
  viFilter: VIType[],
  vit: VICategory,
): InsightVIProps => {
  // get the first summary that matches the VI category
  const summaryCollision = summaries?.filter(summary => summary.vit === vit)?.[0];
  // Apply filters to the summary display, or return placeholder data if the summary is not available (loading).
  return summaryCollision ? getFilteredSummary(summaryCollision, viFilter) : getPlaceholder(vit);
};

interface InsightsCardVIProps {
  summaries?: VISummaryModel[];
}

export function InsightsCardVI({ summaries }: InsightsCardVIProps) {
  const viFilter = useAppSelector(state => state.filters.saved.vehicleInteractionTypes);

  const filteredSummaries = useMemo(() => {
    const summaryCollision = getDisplaySummary(summaries, viFilter, VICategory.Collision);
    const summaryTailgating = getDisplaySummary(summaries, viFilter, VICategory.Tailgating);

    return [summaryCollision, summaryTailgating];
  }, [viFilter, summaries]);

  return (
    <InsightsCard
      cols={2}
      sections={filteredSummaries.map((summary: InsightVIProps) => (
        <InsightVI key={summary.vit} {...summary} />
      ))}
    />
  );
}

export default InsightsCardVI;
